<template>
  <div class="level" :class="{ '--mistake': isMistake }">
    <div class="level__inner">
      <div class="level__lenta" :style="{ transform: `translateY(-${lentaPosition}px)` }">
        <div class="level__lenta-items" ref="docs">
          <div
            class="level__lenta-item"
            :class="[`--${item.type}`, item.subtype ? `--${item.subtype}` : null]"
            v-for="item in docs"
            :key="item.id"
          >
            <div v-if="item.type === 'brief'" class="level__brief">
              <div v-if="item.subtype === 'calendar'" class="level__brief-info">
                Календарь
              </div>
              <div class="level__brief-title">{{ item.title }}</div>
              <div class="level__brief-text">{{ item.text }}</div>
            </div>
            <div v-if="item.type === 'doc'" class="level__doc">
              <h4 class="level__doc-title">
                {{ item.title }}
              </h4>
              <div class="level__doc-text">
                {{ item.text }}
              </div>

              <div class="level__doc-buttons">
                <button class="level__doc-button --no" v-if="!item.isDecided" @click="decline(item)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                    <path
                      fill="#887770"
                      fill-rule="nonzero"
                      d="M12.908 10.636L23.054.49l2.263 2.263L15.17 12.898 25.442 23.17l-2.273 2.273L12.9 15.171l-10.21 10.21-2.263-2.264 10.21-10.209L.442 2.715 2.715.442l10.193 10.194z"
                    />
                  </svg>
                </button>
                <button class="level__doc-button --yes" v-if="!item.isDecided" @click="approve(item)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="26" viewBox="0 0 36 26">
                    <path
                      fill="#887770"
                      fill-rule="nonzero"
                      d="M12.414 26L0 13.62l2.488-2.48 9.926 9.898L33.512 0 36 2.481z"
                    />
                  </svg>
                </button>

                <div class="level__doc-result --green" v-if="item.isGood && item.isDecidedRight">Подписано!</div>
                <div class="level__doc-result --green" v-if="!item.isGood && item.isDecidedRight">Отклонено!</div>
                <div
                  class="level__doc-result --red --description"
                  v-if="item.isGood && item.isDecided && !item.isDecidedRight"
                >
                  Отклонено!
                  <div class="level__doc-error">
                    {{ item.error }}
                  </div>
                </div>
                <div
                  class="level__doc-result --red --description"
                  v-if="!item.isGood && item.isDecided && !item.isDecidedRight"
                >
                  Неверно!
                  <div class="level__doc-error">
                    {{ item.error }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.type === 'adv'" class="level__adv">
              <img src="../assets/megafon-logo-start.svg" alt="" />
              <div class="level__adv-text">
                <div class="level__adv-strong">
                  {{ item.text }}
                </div>
                <div v-if="item.subtext">
                  {{ item.subtext }}
                </div>
                Найми на работу МегаФон!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level__bottom">
      <div class="level__bottom-inner">
        <div class="level__bottom-item --level">
          <strong>{{ level }}</strong>
          <span>Уровень</span>
        </div>
        <div class="level__bottom-item --lives">
          <strong :class="{ '--changed': isLivesChanged }">{{ lives }}</strong>
          <span>Жизни</span>
        </div>
        <div class="level__bottom-item --docs">
          <strong :class="{ '--changed': isDocsChanged }">{{ goodDocsCount }}/{{ goodDocsTotal }}</strong>
          <span>Документы</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import levels from '../data/levels'
import shuffle from '../utils/shuffle'

const elementsAnimationDuration = 110

const errors = shuffle([
  'Ой! Кажется, вы ошиблись!',
  'Это важный документ! Вам стоит быть внимательнее.',
  'Так не пойдет, соберитесь!',
  'Без вашей подписи никуда! Будьте внимательны.',
  'Увы, вы отклонили важный документ.',
])

let advs = [
  {
    text: 'Мобильная Электронная Подпись',
    subtext:
      'услуга, в которой реализована технология, обеспечивающая защищенную аутентификацию пользователей, безопасное online-взаимодействие и подтверждение операций с сертификатом ЭП в системах ЭДО.',
  },
  {
    text:
      'МЭП ничем не отличается от классического понимания ЭЦП. Она квалифицированная и является аналогом собственноручной подписи.',
  },
  { text: 'МЭП мобильна и доступна к использованию при наличии мобильной связи.' },
  {
    text:
      'Снижайте издержки при заключении сделок. Подписывайте и/или согласовывайте любые электронные документы при помощи МЭП в любой точке РФ с мобильного телефона или планшета.',
  },
  { text: 'МЭП доступна к использованию в международном роуминге.' },
  {
    text:
      'МЭП не требует установки на ПК сложных программ шифрования и покупки дополнительных устройств, таких как ключ.',
  },
]

const getDocs = level => {
  let docs = []

  docs = docs.concat(
    levels[level].good.map((item, i) => ({
      ...item,
      type: 'doc',
      isGood: true,
      id: 'good-' + i,
      isDecided: false,
      isDecidedRight: false,
    }))
  )
  docs = docs.concat(
    levels[level].bad.map((item, i) => ({
      ...item,
      type: 'doc',
      isGood: false,
      id: 'bad-' + i,
      isDecided: false,
      isDecidedRight: false,
    }))
  )
  docs = shuffle(docs)

  advs = advs.map((adv, index) => {
    return {
      ...adv,
      id: 'adv-' + index,
      type: 'adv',
    }
  })

  if (level === 0) {
    docs.splice(8, 0, advs[1])
    docs.splice(3, 0, advs[0])
  }

  if (level === 1) {
    docs.splice(10, 0, advs[2])
    docs.splice(5, 0, advs[3])
  }

  if (level === 2) {
    docs.splice(12, 0, advs[4])
    docs.splice(7, 0, advs[5])
  }

  docs = levels[level].brief
    .map((item, i) => ({
      ...item,
      type: 'brief',
      id: 'brief-' + i,
    }))
    .concat(docs)

  return docs
}

export default {
  name: 'Level',
  props: {
    level: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      lives: 3,
      goodDocsCount: 0,
      docs: getDocs(this.level - 1),
      $docs: [],
      lentaPosition: 0,
      isMistake: false,
      isLivesChanged: false,
      isDocsChanged: false,
    }
  },
  computed: {
    goodDocsTotal() {
      return levels[this.level - 1].good.length
    },
    speed() {
      return levels[this.level - 1].speed
    },
  },
  created() {
    this.isLentaStarted = false
    this.lentaPrevTime = 0
    this.topDocRefIndex = 0
  },
  methods: {
    move() {
      if (!this.isLentaStarted) return
      window.requestAnimationFrame(() => {
        if (!this.isLentaStarted) return
        const now = Date.now()
        const timeDiff = now - this.lentaPrevTime

        this.lentaPosition += this.speed * (timeDiff / 1000)

        this.checkTopDoc()

        this.lentaPrevTime = now
        this.move()
      })
    },
    getErrorForGood() {
      const error = errors.shift()
      errors.push(error)

      return error
    },
    startLenta() {
      this.isLentaStarted = true
      this.lentaPrevTime = Date.now()
      this.move()
    },
    checkTopDoc() {
      const rect = this.topDocEl.getBoundingClientRect()
      if (rect.bottom - this.viewportTop <= 0) {
        this.onTopDocOut()
      }
    },
    updateTopDocElement() {
      if (!this.$refs.docs) {
        return
      }
      this.topDocEl = this.$refs.docs.firstChild
    },
    approve(item) {
      item.isDecided = true

      if (item.isGood) {
        item.isDecidedRight = true
        this.onRightMove()
        this.goodDocsCount++
        this.isDocsChanged = true
        setTimeout(() => {
          this.isDocsChanged = false
        }, elementsAnimationDuration)

        const isCheater = window.location.host === 'localhost:8081' && window.location.search.includes('cheater')
        if (isCheater || this.goodDocsCount === this.goodDocsTotal) {
          this.onSuccess()
        }
      } else if (item.type === 'doc' && !item.isGood) {
        this.onMistake()
      }
    },
    decline(item) {
      item.isDecided = true

      if (item.type === 'doc' && !item.isGood) {
        item.isDecidedRight = true
        this.onRightMove()
      } else if (item.isGood) {
        item.error = this.getErrorForGood()
        this.onMistake()
      }
    },
    onTopDocOut() {
      const topDoc = this.docs.shift()

      if (topDoc.type === 'doc' && !topDoc.isDecided) {
        this.isMistake = true
        setTimeout(() => (this.isMistake = false), 350)

        this.onMistake()

        this.$root.$emit('docMiss')
      }

      if (topDoc.type !== 'brief') {
        topDoc.isDecided = false
        topDoc.isDecidedRight = null
        this.docs.push(topDoc)
      }

      this.lentaPosition -= this.topDocEl.offsetHeight + 10 // margin

      this.$nextTick(() => {
        this.updateTopDocElement()
      })
    },
    onMistake() {
      this.lives -= 1
      this.isLivesChanged = true
      setTimeout(() => {
        this.isLivesChanged = false
      }, elementsAnimationDuration)
      if (this.lives === 0) {
        setTimeout(() => {
          this.onFail()
        }, 1000)
      }
    },
    onRightMove() {},
    onFail() {
      console.log('lose!')
      this.$emit('lose')
    },
    onSuccess() {
      console.log('win!')
      this.$emit('win')
    },
  },
  mounted() {
    this.updateTopDocElement()
    setTimeout(() => {
      this.startLenta()
    }, 3000)
    setTimeout(() => {
      this.viewportTop = this.$el.getBoundingClientRect().top
    }, 310)
  },
  beforeDestroy() {
    this.isLentaStarted = false
  },
}
</script>

<style lang="scss">
@keyframes shake {
  10%,
  90% {
    transform: translateX(-1px);
  }
  20%,
  80% {
    transform: translateX(2px);
  }
  30%,
  50%,
  70% {
    transform: translateX(-4px);
  }
  40%,
  60% {
    transform: translateX(4px);
  }
}

.level {
  width: 100%;
  height: inherit;
  overflow-y: hidden;
  padding-bottom: 70px;
  position: relative;
  border-bottom-left-radius: 28px;
  border-bottom-right-radius: 28px;

  &.--mistake {
    .level__inner {
      animation: shake 0.3s infinite;
    }
  }

  &__bottom {
    height: 70px;
    line-height: 25px;
    font-size: 14px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    z-index: 3;
    background: #e6e6e6;

    @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
      position: absolute;
      width: 100%;
      border-bottom-left-radius: 28px;
      border-bottom-right-radius: 28px;
    }

    &-inner {
      max-width: 320px;
      width: 100%;
      display: flex;
      margin: 0 auto;
      justify-content: space-between;
      padding: 0 10px;
    }

    &-item {
      width: 32%;
      text-align: center;

      strong {
        display: inline-block;
        padding-left: 28px;
        margin-top: 15px;
        background: url(../assets/star.svg) no-repeat left center;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-weight: normal;
      }

      &.--lives strong {
        transition: transform 0.1s ease-in-out;
        transform-origin: 50% 100%;
        background: url(../assets/heart.svg) no-repeat left center;
        &.--changed {
          transform: scale(1.2);
        }
      }

      &.--docs strong {
        transition: transform 0.1s ease-in-out;
        transform-origin: 50% 100%;
        background: url(../assets/doc.svg) no-repeat 4px center;
        &.--changed {
          transform: scale(1.2);
        }
      }

      span {
        display: block;
        font-size: 12px;
        line-height: 12px;
        margin-top: 7px;
        color: #554b46;
      }
    }
  }

  &__lenta {
    padding: 10px;
    /*top: calc(100% - 70px);*/
    top: 0;
    position: absolute;
    width: 100%;
    left: 0;
    will-change: transform;
    &-item {
      margin: 0 0 10px;
      border-radius: 3px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
      padding: 0px;
      background: #fff;
      line-height: 20px;

      &.--calendar {
        background: url(../assets/calendar.svg) no-repeat right 20px top 20px;
        background-color: #cef4f7;
      }

      &.--security {
        background: url(../assets/security.svg) no-repeat left 20px top 20px #fff;
        .level__brief-title {
          margin-left: 60px;
        }
      }

      &.--adv {
        background: #00b956;
        font-size: 15px;
        line-height: 20px;
        padding: 20px;
        .level__adv-strong {
          font-weight: bold;
        }
      }
    }
  }

  &__brief {
    padding: 20px;
    font-size: 15px;

    &-info {
      margin-bottom: 10px;
      color: rgba(0, 0, 0, 0.5);
    }

    &-title {
      font-size: 16px;
      color: #000;
      font-weight: bold;
      width: 190px;
      margin-bottom: 10px;
    }
  }

  &__doc {
    position: relative;
    padding: 20px;

    &-title {
      font-size: 16px;
      line-height: 20px;
      font-weight: bold;
      padding: 0;
      margin: 0 0 10px;
    }

    &-text {
      font-size: 15px;
      line-height: 20px;
    }

    &-buttons {
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    &-button {
      padding: 0;
      margin: 0;
      border: none;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      width: 60px;
      height: 60px;
      line-height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      border-radius: 50%;
      transition: background-color 0.15s ease-in-out;
      background-color: #fff;
      svg path {
        transition: fill 0.15s ease-in-out;
      }

      &.--yes {
        &:hover {
          background-color: #00b956;
          svg path {
            fill: #fff;
          }
        }
      }
      &.--no {
        &:hover {
          background-color: #eb5a40;
          svg path {
            fill: #fff;
          }
        }
      }
    }

    &-result {
      color: #00b956;
      font-size: 24px;
      line-height: 30px;
      font-weight: bold;
      padding-top: 13px;
      padding-bottom: 17px;

      &.--red {
        color: #eb5a40;
      }

      &.--description {
        padding-top: 0;
        padding-bottom: 0;
        line-height: 26px;
      }
    }

    &-error {
      font-size: 15px;
      line-height: 20px;
      font-weight: normal;
      margin-top: 20px;
    }
  }

  &__adv {
    &-text {
      margin-top: 10px;
      color: #fff;
    }
  }
}
</style>
